export default __webpack_public_path__ + "static/16_18-8740b0932a3bcd4fe869b8f6f8593797.png";